import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchInvitations } from "../invitations/slice"
import adapter, { subAdapter } from "./adapter"
import service from "./service"
import invitationAdapter from '../invitations/adapter'
import apiService from "../api/service"
import programAdapter from '../program/adapter'
import programsAdapter from '../programs/adapter'
import eventAdapter from '../event/adapter'
import resourceAdapter from '../resource/adapter'
import blogAdapter from '../blog/adapter'
import bulkAdapter from '../organizations/adapter'
import { getCoordinateObject } from "../../utils"

const NAME = 'organization'

const initialData = {
  branch_invitations_sent: [],
  branch_invitations_received: [],
  headquarter: {},
  branches: []
}

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: initialData,
  members: [],
  members_options: [],

  featured_programs: [],
  featured_events: [],
  featured_resources: [],
  featured_blogs: [],

  headquarter: {},
  branches: [],
  branch_data_by_province: [],
  branch_data_by_city: [],
  branch_data_map: [],
  branch_data_map_nested: [],

  renderable: {
    pageHeader: {
      cardMetas: {
        types: [],
        since: [],
        approaches: [],
        location: [],
        issues: []
      }
    }
  },

  // Map
  data_by_province: [],
  data_by_city: [],
  data_map: [],
  data_map_nested: [],

  statistics: {
    programByYear: {
      data: [],
      total: 0
    },
    beneficiariesByYear: {
      data: [],
      total: 0
    },
    approach: {
      data: [],
      total: 0
    },
    issues: {
      data: [],
      total: 0
    },
    location: {
      data: [],
      total: 0
    }
  },
  program_statistics: {
    data: [],
  },
  event_statistics: {
    data: [],
  },
  resource_statistics: {
    data: [],
  },
  blog_statistics: {
    data: [],
  },

  pdf_field: {
    cover_main_image: true,
    cover_logo: true,
    cover_name: true,
    cover_type: true,
    cover_since: true,
    cover_approach: true,
    cover_issue: true,
    cover_location: true,
    detail_main_image: true,
    detail_description: true,
    detail_statistic: true,
    contact_email: true,
    contact_phone: true,
    contact_website: true,
    contact_social_media: true,
    contact_headquarter: true,
    contact_branch: true,
    contact_partner: true,
    contact_member: true,
    statistic_milestones: true,
    statistic_organization_program: true,
    statistic_organization_event: true,
    statistic_organization_resource: true,
    statistic_organization_blog: true,
    statistic_program_program: true,
    statistic_program_beneficiaries: true,
    statistic_program_gender: true,
    statistic_program_approach: true,
    statistic_program_issue: true,
    statistic_program_location: true,
    program_main_image: true,
    program_description: true,
    program_approach: true,
    program_issue: true,
    program_date: true,
    program_location: true,
    program_beneficiaries: true,
    program_partner: true,
    event_main_image: true,
    event_description: true,
    event_approach: true,
    event_issue: true,
    event_date: true,
    event_type: true,
    event_location: true,
    event_media: true,
    event_guests: true,
    resource_main_image: true,
    resource_description: true,
    resource_approach: true,
    resource_issue: true,
    resource_type: true,
    resource_category: true,
    blog_main_image: true,
    blog_description: true,
    blog_approach: true,
    blog_issue: true,
    blog_category: true,
  }
};

export const fetchOrganization = createAsyncThunk(
  `${NAME}/fetchOrganization`,
  async (id) => await service.get(id)
);

export const fetchStatistics = createAsyncThunk(
  `${NAME}/fetchStatistics`,
  async (id) => await service.getStatistics(id)
);

export const fetchProgramStatistics = createAsyncThunk(
  `${NAME}/fetchProgramStatistics`,
  async () => await apiService.getStatistic('organization_programs1')
    .then(res => {
      if(res){
        const {
          beneficiariesMen = 0,
          beneficiariesMenDifable = 0,
          beneficiariesWomen = 0,
          beneficiariesWomenDifable = 0,
          lokasiProgramsByJalan = [],
          programTerdaftar = 0,
          totalCompleted = 0,
          totalOngoing = 0
        } = res

        const newTotalBeneficiaries =
          beneficiariesMen
          + beneficiariesMenDifable
          + beneficiariesWomen
          + beneficiariesWomenDifable

        return {
          ongoing: totalOngoing,
          completed: totalCompleted,
          total: programTerdaftar,
          totalBeneficiaries: newTotalBeneficiaries,
          totalLocation: lokasiProgramsByJalan.length,
          data: [
            {name: 'Completed', value: totalCompleted},
            {name: 'Ongoing', value: totalOngoing}
          ],
        }
      }
    })
    .catch(err => {
      console.log({err})
      return err
    })
);

export const fetchEventStatistics = createAsyncThunk(
  `${NAME}/fetchEventStatistics`,
  async () => await apiService.getStatistic('organization_events1')
  .then(res => {
    console.log({res})
    if(res){
      const {
        lokasiEventsByJalan = [],
        eventTerdaftar = 0,
        totalUpcoming = 0,
        totalCompleted = 0,
        totalActivityParticipant = 0
      } = res

      return {
        total: eventTerdaftar,
        upcoming: totalUpcoming,
        past: totalCompleted,
        totalGuests: totalActivityParticipant,
        totalLocation: lokasiEventsByJalan.length,
        data: [
          {name: 'Past', value: totalCompleted},
          {name: 'Upcoming', value: totalUpcoming}
        ]
      }
    }
  })
  .catch(err => {
    console.log({err})
    return err
  })
);

export const fetchResourceStatistics = createAsyncThunk(
  `${NAME}/fetchResourceStatistics`,
  async () => await apiService.getStatistic('organization_resources1')
    .then(res => {
      if(res){
        const {
          resourceTerdaftar = 0,
          kategoriArtikel = [],
        } = res

        return {
          total: resourceTerdaftar,
          data: kategoriArtikel.map(k => ({name: k[0], value: k[1]}))
        }
      }
    })
    .catch(err => {
      console.log({err})
      return err
    })
);

export const fetchBlogStatistics = createAsyncThunk(
  `${NAME}/fetchBlogStatistics`,
  async () => await apiService.getStatistic('organization_blogs1')
    .then(res => {
      if(res){
        const {
          blogTerdaftar = 0,
          kategoriArtikel = [],
        } = res

        return {
          total: blogTerdaftar,
          data: kategoriArtikel.map(k => ({name: k[0], value: k[1]}))
        }
      }
    })
    .catch(err => {
      console.log({err})
      return err
    })
);

export const fetchHeadquarter = createAsyncThunk(
  `${NAME}/fetchHeadquarter`,
  async (id) => await service.get(id)
);

export const fetchBranches = createAsyncThunk(
  `${NAME}/fetchBranches`,
  async (data /* 'data' is from store.state.organization.data.branches */) => {
    const promises = []

    if(data && data.length > 0){
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if(element.id){
          const promise = await service.get(element.id)
          promises.push(promise)
        }
      }
    }

    return Promise.all(promises)
  }
);

export const sendBranchInvitations = createAsyncThunk(
  `${NAME}/sendBranchInvitation`,
  async (data) => {
    const {id, ids} = data
    const promises = []

    for (let index = 0; index < ids.length; index++) {
      const element = ids[index];
      const requestBody = {
        requestBranch: element
      }
      const promise = await apiService.update('organizations_update', id, requestBody)
      promises.push(promise)
    }

    return Promise.all(promises)
  }
);

export const organizationSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    reset(state){
      state.data = initialData
    },
    setPdfField(state, action){
      state.pdf_field = action.payload
    }
  },
  extraReducers: {
    [fetchOrganization.pending]: (state) => {
      state.status = "loading";
    },
    [fetchOrganization.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const organization = action.payload;
      state.data = adapter.responseBodyToRender(organization);

      const featuredPrograms = organization.featuredContent?.featuredProgram
      if(featuredPrograms){
        state.featured_programs = featuredPrograms.map(p => programAdapter.responseBodyToRenderBasic(p))
      }

      const featuredEvents = organization.featuredContent?.featuredEvent
      if(featuredEvents){
        state.featured_events = featuredEvents.map(p => eventAdapter.responseBodyToRender(p))
      }

      const featuredResources = organization.featuredContent?.featuredResource
      if(featuredResources){
        state.featured_resources = featuredResources.map(p => resourceAdapter.responseBodyToRender(p))
      }

      const featuredBlogs = organization.featuredContent?.featuredBlog
      if(featuredBlogs){
        state.featured_blogs = featuredBlogs.map(p => blogAdapter.responseBodyToRender(p))
      }

      if(organization.teamMember){
        state.members = subAdapter.member.responseBodyToRender(organization.teamMember)
        state.members_options = subAdapter.member.responseBodyToOptions(organization.teamMember)
      }

      // Map
      const withLocationOnly = [organization].filter(org => org.lokasiOrganisasi && org.lokasiOrganisasi.length > 0)
      const withValidLocationOnly = withLocationOnly.map(org => {
        const cloned = {...org}
        let newLocations = []

        const locations = org.lokasiOrganisasi

        if(locations && locations.length > 0){
          for (let index = 0; index < locations.length; index++) {
            const lokasi = locations[index];
            const coordinateString = lokasi.pinLocation
            const coordinateObject = getCoordinateObject(coordinateString)
            if(coordinateObject){
              newLocations.push(lokasi)
            }
          }
        }

        cloned.lokasiOrganisasi = newLocations
        return cloned
      })

      const dataByProvince = bulkAdapter.responseBodyToByProvince(withValidLocationOnly)
      state.data_by_province = dataByProvince
      const dataByCity = bulkAdapter.byProvinceToByCity(dataByProvince)
      state.data_by_city = dataByCity
      state.data_map = bulkAdapter.responseBodyToMap(dataByCity)
      const dataMapNested = bulkAdapter.responseBodyToMapNested(dataByCity)
      state.data_map_nested = dataMapNested
      const provinces = Object.keys(dataByProvince.organizationsByProvinceByHub).map(province => dataByProvince.organizationsByProvinceByHub[province].totalBranch)
      const totalCities = provinces.reduce((a, b) => a + b)
      state.total_cities = totalCities
    },
    [fetchOrganization.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [fetchInvitations.fulfilled]: (state, action) => {
      state.invitations = action.payload
        .map(a => invitationAdapter.responseBodyToRender(a))
        // type 1 = invitation; organisasi mengundang seorang individu untuk bergabung.
        // type 2 = join request; seorang individu meminta untuk bergabung dengan organisasi.
        .filter(a => a.type === 1)
    },

    [fetchHeadquarter.fulfilled]: (state, action) => {
      const organization = action.payload;
      state.headquarter = adapter.responseBodyToRender(organization);
    },

    [fetchBranches.fulfilled]: (state, action) => {
      state.branches = action.payload.map(o => adapter.responseBodyToRender(o))

      // Map
      const withLocationOnly = action.payload.filter(org => org.lokasiOrganisasi && org.lokasiOrganisasi.length > 0)
      const withValidLocationOnly = withLocationOnly.map(org => {
        const cloned = {...org}
        let newLocations = []

        const locations = org.lokasiOrganisasi

        if(locations && locations.length > 0){
          for (let index = 0; index < locations.length; index++) {
            const lokasi = locations[index];
            const coordinateString = lokasi.pinLocation
            const coordinateObject = getCoordinateObject(coordinateString)
            if(coordinateObject){
              newLocations.push(lokasi)
            }
          }
        }

        cloned.lokasiOrganisasi = newLocations
        return cloned
      })

      const dataByProvince = bulkAdapter.responseBodyToByProvince(withValidLocationOnly)
      state.branch_data_by_province = dataByProvince
      const dataByCity = bulkAdapter.byProvinceToByCity(dataByProvince)
      state.branch_data_by_city = dataByCity
      state.branch_data_map = bulkAdapter.responseBodyToMap(dataByCity)
      const dataMapNested = bulkAdapter.responseBodyToMapNested(dataByCity)
      state.branch_data_map_nested = dataMapNested
      const provinces = Object.keys(dataByProvince.organizationsByProvinceByHub).map(province => dataByProvince.organizationsByProvinceByHub[province].totalBranch)
      const totalCities = provinces.reduce((a, b) => a + b)
      state.branch_total_cities = totalCities
    },

    [fetchStatistics.fulfilled]: (state, action) => {
      const { payload } = action
      state.statistics = programsAdapter.responseBodyToStatistic(payload)
    },

    [fetchProgramStatistics.fulfilled]: (state, action) => {
      const { payload } = action
      if(payload){
        state.program_statistics = payload
      }
    },

    [fetchEventStatistics.fulfilled]: (state, action) => {
      const { payload } = action
      if(payload){
        state.event_statistics = payload
      }
    },

    [fetchResourceStatistics.fulfilled]: (state, action) => {
      const { payload } = action
      if(payload){
        state.resource_statistics = payload
      }
    },

    [fetchBlogStatistics.fulfilled]: (state, action) => {
      const { payload } = action
      if(payload){
        state.blog_statistics = payload
      }
    }
  }
});

export const {
  setStatus,
  updateForm,
  reset,
  setPdfField
} = organizationSlice.actions

export default organizationSlice.reducer;
